import { ScreeningCheckStatus } from "common/types/services/api/offers/offer-item-dto.type";

enum BackgroundReportStatus {
  Clear = 'clear',
}

const screeningStatusTitles: Record<ScreeningCheckStatus, string> = {
  [ScreeningCheckStatus.NotRequested]: "Background check is not requested",
  [ScreeningCheckStatus.RequestedLandlord]: "Background check requested",
  [ScreeningCheckStatus.RequestedRenter]: "Background check requested",
  [ScreeningCheckStatus.Completed]: "Background check completed",
}

export { BackgroundReportStatus, screeningStatusTitles };
